/**
 * The open chat's public uuid, kept ONLY for the in-app tab-restore flow.
 *
 * App.tsx reads it when the user switches back to the Assistant tab and
 * navigates to /assistant/{uuid}, so a turn that kept running through the tab
 * switch is still on screen when they return. A typed or reloaded bare
 * /assistant URL never consults it — the URL is the source of truth and bare
 * /assistant is the new-chat page (#603). Pre-#603 values under this key were
 * numeric ids; the uuid check ignores them.
 *
 * Its own module (#1678) because the shell reads it: a value import from
 * `AssistantView.tsx` would pull the whole 5,000-line view into the shell
 * chunk and undo the per-tab split.
 */
export function assistantSessionStorageKey(householdId: string): string {
  return `assistant.activeSession.${householdId}`;
}

const chatUuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function readStoredAssistantChatId(householdId: string): string | null {
  try {
    const raw = window.sessionStorage.getItem(assistantSessionStorageKey(householdId));
    return raw && chatUuidPattern.test(raw) ? raw : null;
  } catch {
    return null;
  }
}
